import { Link } from "react-router-dom";

export default function BookCall() {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="book-page">
      <header className="border-b border-border bg-card">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2"><div className="h-8 w-8 rounded-md bg-primary text-primary-foreground grid place-items-center font-display text-base">O</div><div className="font-display text-xl">ORIXA</div></Link>
        </div>
      </header>
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="text-overline text-primary mb-3">Product Demo</div>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight" data-testid="book-title">Product demo of the Orixa Invest software platform</h1>
        <p className="mt-4 text-muted-foreground max-w-2xl text-sm sm:text-base">
          A 30-minute walkthrough of the Orixa Invest software subscription — AI research engine, country data, downloadable digital reports and team workspaces. No obligation, no sales pressure.
        </p>
        <div className="mt-8 sm:mt-10 bg-card border border-border rounded-2xl p-6 sm:p-8 card-elev grid grid-cols-1 sm:grid-cols-2 gap-6" data-testid="book-contact">
          <div>
            <div className="text-overline text-muted-foreground mb-2">Book instantly</div>
            <a href="https://cal.com/romuald-ouattara-wttutm/call-orixa-invest"
               target="_blank" rel="noopener noreferrer"
               className="inline-flex items-center gap-2 bg-primary text-primary-foreground rounded-lg px-5 py-3 text-sm font-semibold hover:opacity-90 card-elev"
               data-testid="book-primary-cta">
              Book a product demo
            </a>
            <p className="mt-3 text-xs text-muted-foreground">Pick a slot on our calendar — 30 minutes, no obligation.</p>
            <p className="mt-2 text-xs text-muted-foreground">
              Prefer email? Reach us at <a href="mailto:sales@orixa-invest.co" className="text-primary underline" data-testid="book-sales-email">sales@orixa-invest.co</a>.
            </p>
          </div>
          <div>
            <div className="text-overline text-muted-foreground mb-2">Or start immediately</div>
            <Link to="/pricing" className="inline-flex items-center gap-2 border border-border rounded-lg px-5 py-3 text-sm font-semibold hover:bg-secondary" data-testid="book-pricing-cta">
              View software plans
            </Link>
            <p className="mt-3 text-xs text-muted-foreground">Self-serve subscription. Instant activation. Cancel any time.</p>
          </div>
        </div>
        <p className="mt-8 text-xs text-muted-foreground max-w-2xl leading-relaxed">
          Orixa Invest is a subscription-based software platform developed by Ibn Miyeta Group. This page is only for product demos of the software. Any external execution support is handled by unaffiliated partners under separate contracts and is not part of your Orixa Invest subscription.
        </p>
      </section>
    </div>
  );
}
